import axios from 'axios';

// 创建axios实例
const apiClient = axios.create({
  baseURL: '/api', // 统一使用 /api 代理路径
  timeout: 10000, // 请求超时时间
});

// 请求拦截器 - 在每个请求头中添加token
apiClient.interceptors.request.use(
  config => {
    // 对于登录请求，不需要添加token
    if (!config.url?.includes('/auth/login')) {
      // 从localStorage获取token
      const token = localStorage.getItem('token');
      if (token) {
        // 修改认证头格式，与utils/request.ts保持一致
        config.headers!['token'] = token;
      }
    }
    
    // 设置正确的Content-Type
    if (!config.headers!['Content-Type']) {
      config.headers!['Content-Type'] = 'application/json';
    }
    
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理响应
apiClient.interceptors.response.use(
  response => {
    // 根据项目规范，直接返回response.data
    return response.data;
  },
  error => {
    // 处理错误响应
    // 仅在401错误时才移除token
    if (error.response?.status === 401) {
      // Token过期或无效，移除本地token
      localStorage.removeItem('token');
    }
    return Promise.reject(error);
  }
);

/**
 * 用户注册接口
 * @param userData - 用户注册数据
 */
export function register(userData: {
  username: string;
  name: string;
  password: string;
  email?: string;
  phone?: string;
}) {
  return apiClient.post('/auth/register', userData);
}

/**
 * 用户登录接口
 * @param credentials - 用户登录凭据
 */
export function login(credentials: { username: string; password: string }) {
  return apiClient.post('/auth/login', credentials, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

/**
 * 用户登出接口
 */
export function logout() {
  return apiClient.post('/auth/logout');
}